import React, { startTransition } from 'react';
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { joiResolver } from "@hookform/resolvers/joi";

import css from './ForgotPasswordComponent.module.css';
import { forgotPasswordValidator } from "../../validators";
import { getConfig } from "../../config";


const ForgotPasswordComponent = () => {
    const navigate = useNavigate();
    const config = getConfig();

    const submit = (data) => {
        console.log('Form Data:', data);

        startTransition(() => {
            navigate('/login');
        });
    };

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: joiResolver(forgotPasswordValidator),
        mode: 'onBlur',
    });

    return (
        <section className={css.container}>
            {/* Logo */}
            <div className={css.logoArea}>
                <img src={config.logo} alt={config.title} className={css.logo} />
            </div>

            {/* Heading */}
            <div className={css.headingArea}>
                <h1 className={css.title}>Need help?</h1>
                <p className={css.subtitle}>Enter your email and we'll get back to you</p>
            </div>

            <form onSubmit={handleSubmit(submit)} className={css.form}>
                <div className={css.fieldGroup}>
                    <label htmlFor="email" className={css.label}>
                        <span className={css.labelRequired}>* </span>Email address
                    </label>
                    <div className={css.inputWrap}>
                        <span className={css.inputIcon}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                            </svg>
                        </span>
                        <input
                            id="email"
                            type="email"
                            placeholder="admin@example.com"
                            {...register('email')}
                            aria-invalid={!!errors.email}
                            aria-describedby="email-error"
                            className={`${css.input} ${errors.email ? css.inputError : ''}`}
                        />
                    </div>
                    {errors.email && (
                        <p id="email-error" className={css.error}>{errors.email.message}</p>
                    )}
                </div>

                <button type="submit" className={css.button} disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </form>

            <Link to="/login" className={css.backLink}>
                ← Back to sign in
            </Link>
        </section>
    );
};

export { ForgotPasswordComponent };
